import { Layout } from "../components/Layout";
import { Panel } from "../components/Panel";
import { t, useWorkspaceLanguage, withLanguagePrefix } from "../lib/i18n";

export function Home() {
  const language = useWorkspaceLanguage();
  const labels = t(language);

  return (
    <Layout
      eyebrow={labels.home.eyebrow}
      title={labels.home.title}
      description={labels.home.description}
    >
      <div className="hero-actions">
        <a className="button button-primary" href={withLanguagePrefix("/login", language)}>
          {labels.home.cta}
        </a>
        <a className="button button-secondary" href={withLanguagePrefix("/pricing", language)}>
          {labels.home.pricingCta}
        </a>
      </div>

      <div className="grid grid-3">
        {labels.home.cards.map((card) => (
          <Panel key={card.title} title={card.title}>
            <p>{card.body}</p>
          </Panel>
        ))}
      </div>
    </Layout>
  );
}
